module.exports = __webpack_public_path__ + "static/media/error-something.f047f79e.png";